<template>
  <div>Hey</div>
</template>

<script>
export default {
  name: "SelectImage",
};
</script>

<style scoped></style>
